import { useContext, useMemo } from "react"
import { DESC } from "helpers/sorts"
import ContributorsDataIntegrator from "gatherers/contributors-data-integrator"
import ContributorsTable from "renderers/contributors-datagrid"
import { INSTRUMENTS } from "connected-components/dashboard/helpers"
import { useTemplateGatherers } from "connected-components/dashboard/hooks/use-template-gatherers"
import { useFactorViewDashboardMetrics } from "helpers/metrics/hooks"
import { useAnalytics } from "connected-components/analytics"
import { useFactorsViewTableHandlers } from "../../hooks/use-factors-view-table-handlers"
import { FACTORS_VIEW_COMMON_PROPS } from "../../prop-types"

export default function FactorsRiskView({ context, instrumentsWithMetadata, instrumentColumns, driftDates }) {
  const { startDate, base: contextBase, sortMetricId, setSortMetricId, sortDirection, setSortDirection, selectedTableLevels, setSelectedTableLevels, isEndVsStartDateComparison } = useContext(context)

  const analytics = useAnalytics()
  const { handleSortChanged, handleTableNavigationChanged } = useFactorsViewTableHandlers({ track: analytics.track })

  const fromDate = useMemo(() => {
    if (!driftDates) {
      return startDate
    }
    if (startDate < driftDates.startDate) {
      return startDate
    }
    return driftDates.startDate
  }, [startDate, driftDates])

  const gatherers = useTemplateGatherers(context, "factorRisk", {
    useCompositionQueries: false,
    from: startDate,
    driftStartDate: fromDate,
  })

  const metrics = useFactorViewDashboardMetrics(
    [{ category: "factorRisk" }],
    { instrumentColumns, isActive: !!contextBase, instrumentsWithMetadata, isEndVsStartDateComparison },
  )

  const defaultSortSuffix = INSTRUMENTS[instrumentColumns[0]].suffix

  return <ContributorsDataIntegrator
    gatherers={gatherers}
    metrics={metrics}
    Renderer={ContributorsTable}
    rendererProps={{
      groupByName: "Category",
      defaultSort: {
        path: `riskDecomposition${defaultSortSuffix}`,
        direction: DESC,
      },
      disableCategories: true,
      classes: "factors-table",
      idLabel: "Factor",
      hidePagination: true,
      includeDrilldownArrows: true,
      downloadKey: "factors.risk",
      downloadName: "Factors - Risk",
      sortMetricId,
      onSortMetricIdChange: setSortMetricId,
      sortDirection,
      onSortDirectionChange: setSortDirection,
      tableNavigationLevels: selectedTableLevels,
      onTableNavigationChange: setSelectedTableLevels,
      onSortChanged: handleSortChanged,
      onTableNavigationChanged: handleTableNavigationChanged,
      context,
    }}
  />
}

FactorsRiskView.propTypes = FACTORS_VIEW_COMMON_PROPS
